import { __zcFin, __zcIT, __zcITc, __zcIV, __zcMkv, __zcRd, __zcRf } from "__zod-compiler-runtime__";
import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'

export const PrimerComponentLabelSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('primerComponentLabel', {
  fields: z.lazy(() =>
    z.object({
      text: z.string(),
      size: z.enum(['medium', 'large']),
      color: z.enum([
        'default',
        'blue',
        'coral',
        'green',
        'gray',
        'indigo',
        'lemon',
        'lime',
        'orange',
        'pink',
        'purple',
        'red',
        'teal',
        'yellow',
        'blue-purple',
        'green-blue',
        'green-blue-purple',
        'pink-blue',
        'purple-red',
        'red-orange',
      ]),
      icon: z.string().optional(),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"]];
var __rfz_0=__rf[0]._zod;
var __set_enum_14=new Set(["default","blue","coral","green","gray","indigo","lemon","lime","orange","pink","purple","red","teal","yellow","blue-purple","green-blue","green-blue-purple","pink-blue","purple-red","red-orange"]);
function safeParse_PrimerComponentLabelSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_c0={async:false};var __rf_r0=__zcRd(__rfz_0,__sv_6,__rf_c0);if(__rf_r0.issues.length){__zcRf(__rf_r0.issues,__rf_c0,_e,["sys","contentType"]);}else{__sv_6=__rf_r0.value;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];if(typeof __sv_9!=="object"||__sv_9===null||Array.isArray(__sv_9)){_e.push(__zcIT("object",__sv_9,["fields"]));}else{var __sv_11=__sv_9["text"];if(typeof __sv_11!=="string"){_e.push(__zcIT("string",__sv_11,["fields","text"]));}
var __sv_12=__sv_9["size"];if(__sv_12!=="medium"&&__sv_12!=="large"){_e.push(__zcIV(["medium","large"],__sv_12,["fields","size"]));}
var __sv_13=__sv_9["color"];if(!__set_enum_14.has(__sv_13)){_e.push(__zcIV(["default","blue","coral","green","gray","indigo","lemon","lime","orange","pink","purple","red","teal","yellow","blue-purple","green-blue","green-blue-purple","pink-blue","purple-red","red-orange"],__sv_13,["fields","color"]));}
var __sv_15=__sv_9["icon"];if(__sv_15!==undefined){if(typeof __sv_15!=="string"){_e.push(__zcIT("string",__sv_15,["fields","icon"]));}
}
var __o_10={"text":__sv_11,"size":__sv_12,"color":__sv_13};if(__sv_15!==undefined||("icon" in __sv_9)){__o_10["icon"]=__sv_15;}__sv_9=__o_10;}
var __o_0={"sys":__sv_1,"fields":__sv_9};_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_PrimerComponentLabelSchema,__zs,null,null);
})()

export type PrimerComponentLabel = z.infer<typeof PrimerComponentLabelSchema>
